import { useLayoutEffect } from "preact/hooks";

export const useBodyStyle = (...classNames: string[]) => {
    useLayoutEffect(() => {
        document.body.classList.add(...classNames);
        return () => {
            document.body.classList.remove(...classNames);
        };
    }, [classNames.join(' ')]);
};
